export default "__VITE_ASSET__Dr8J$Vti__"